import React from "react";

const PaginationItem = ({ children, setPage, page, active }) => {
  return (
    <li
      onClick={
        setPage
          ? () => {
              setPage(page);
            }
          : () => {}
      }
      className={
        "w-12 h-12 bg-white transition  border-2 rounded  flex items-center justify-center font-semibold text-15 cursor-pointer  hover:border-pagination-colors hover:text-pagination-colors " +
        (active ? "border-pagination-colors" : "border-[#D1DDE0]")
      }
    >
      {children}
    </li>
  );
};

export default PaginationItem;
